import React, { useEffect, useState } from 'react';
import { fetchByket } from '../api';
import TableView from './TableByket';
import ByketForm from './ByketForm';

const CellsByket = () => {
  const [byket, setBykets] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      try {
        const data = await fetchByket();
        setBykets(data);
      } catch (error) {
        console.error('Failed to fetch products:', error);
      }
    };
    loadData();
  }, []);

  return (
    <div className="p-3">
      <h2>Комірки</h2>
      <ByketForm setBykets={setBykets} />
      <TableView bykets={byket} />
    </div>
  );
};

export default CellsByket;
